import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Button, Card, CardBody, CardHeader, Row } from "reactstrap";
import { GetLogs } from "../../services/afasLogService";
import AppModal from "../components/Common/AppModal";
import PageTitle from "../components/Common/PageTitle";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/monikai.css";
import { AFASLogItem } from "../../types";
import { Col } from "react-bootstrap";
import { getProjects } from "../../services/projectService";
import Select from "react-select";
import Input from "react-select/dist/declarations/src/components/Input";
import AppDateInput from "../components/forms/AppDateInput";
import DatePickerFilter from "../components/Common/DateFilterPickr";
import DatePickerInput from "../components/Common/DatePickerInput";

const AfasLogs = () => {
  const [logs, setLogs] = useState<AFASLogItem[]>();
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [currentLogItem, setCurrentLogItem] = useState<AFASLogItem>();
  const [projects, setProjects] = useState([]);
  const [showOnlyError, setShowOnlyErrors] = useState<boolean>(false);
  const [projectFilter, setProjectFilter] = useState<number | undefined>();
  const [dateFromFilter, setDateFromFilter] = useState(undefined)
  const [dateToFilter, setDateToFilter] = useState(undefined)

  const openModel = (row) => {
    setCurrentLogItem(row);
    setShowModal(true);
  };

  async function fetchItems(skipcount, size = perPage, showOnlyError, projectId, dateFrom, dateTo) {
    setLoading(true);

    const response = await GetLogs(size, skipcount, showOnlyError, projectId,  dateFrom, dateTo);

    if (response) {
      setLogs(response.data.result.items);
      setTotalRows(response.data.result.totalCount);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchItems(0, perPage, showOnlyError, projectFilter, dateFromFilter, dateToFilter);
    getProjectDataForFilter();

  }, [showOnlyError, dateFromFilter,dateToFilter]);

  async function getProjectDataForFilter() {
    const result = await getProjects();
    let options = result.data.result.items.map(function (project) {
      return { value: project.id, label: project.name };
    });

    setProjects(options);
  }

  const handlePerRowsChange = async (newPerPage, page) => {
    fetchItems(page * perPage, newPerPage, showOnlyError, projectFilter, dateFromFilter,dateToFilter);
    setPerPage(newPerPage);
  };


  const handleChangeProject = (value) => {
    if (!value) {
      setProjectFilter(undefined);
    } else {
      setProjectFilter(value.value);
    }

    fetchItems(0, perPage, showOnlyError, value ? value.value : undefined, dateFromFilter, dateToFilter);
  };


  const handlePageChange = (page) => {
    fetchItems((page - 1) * perPage, perPage, showOnlyError, projectFilter, dateFromFilter, dateToFilter);
    setCurrentPage(page);
  };

  return (
    <div>
      <>
        <PageTitle title="NetSuite logs" />
        <Row className="mb-3 justify-content-end align-items-center">
          <Col sm="auto">
            <input
              type="checkbox"
              className="form-check-input"
              value="1"
              onClick={(e) => setShowOnlyErrors(e.target.checked)}
              id="errorfilter"
            />
          </Col>
          <Col sm="auto">
            <label htmlFor="errorfilter" className="form-check-label">
              Show only error records
            </label>
          </Col>
          <Col lg={6} sm={6}>
            <h6>Project</h6>
            <Select isClearable options={projects} onChange={handleChangeProject} />
          </Col>
          </Row>
          <Row className="mb-3 justify-content-end align-items-center">

          <Col lg={6} sm={6}>
            <h6>Date from</h6>
            <DatePickerInput
             handleChange={e => {
              setDateFromFilter(e)
            }}
              maxDate={dateToFilter}
              dateValue={dateFromFilter}
               />
          </Col>      <Col lg={6} sm={6}>
            <h6>Date to</h6>
            <DatePickerInput handleChange={e => setDateToFilter(e)}
              minDate={dateFromFilter}
              dateValue={dateToFilter}
              />
          </Col>
        </Row>

        {loading ? (
          <Row className="text-center">
            <h4>Loading...</h4>
          </Row>
        ) : (
          <Row>
            <DataTable
              pagination
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              paginationPerPage={perPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              paginationServer
              responsive
              columns={[
                {
                  name: "id",
                  selector: (row) => row.id,
                  sortable: false,
                },
                {
                  name: "message",
                  selector: (row) => row.message,
                  sortable: false,
                },
                {
                  name: "created",
                  selector: (row) =>
                    moment(row.created).format("dddd | DD-MM-yyyy | HH:mm:ss"),
                  sortable: false,
                },
                {
                  name: "Actions",
                  cell: (row) => (
                    <Button
                      onClick={() => openModel(row)}
                      size="m"
                      color="primary"
                    >
                      <FontAwesomeIcon icon={faInfo} size="xs" />
                    </Button>
                  ),
                },
              ]}
              data={logs!}
            />
          </Row>
        )}

        <AppModal
          show={showModal}
          title="AFAS log"
          handleHide={() => {
            setShowModal(!showModal);
          }}
        >
          <>
            {currentLogItem && (
              <div className="d-flex mb-3">
                <Card className="w-100">
                  <CardHeader>
                    Message was: <strong>{currentLogItem.message}</strong> on{" "}
                    <strong>
                      {moment(currentLogItem.created).format(
                        "DD-MM-YYYY HH:mm"
                      )}
                    </strong>
                  </CardHeader>
                  <CardBody>
                    <strong>The following request was send to AFAS:</strong>

                    <JSONPretty
                      id="json-pretty"
                      data={currentLogItem.requestJson}
                    ></JSONPretty>
                    <strong>We recieved the following response:</strong>
                    <JSONPretty
                      id="json-pretty"
                      data={currentLogItem.responseJson}
                    ></JSONPretty>
                    {currentLogItem.responseDescription && (
                      <>
                        <strong>What do we need to do with this error? </strong>
                        <>{currentLogItem.responseDescription}</>
                      </>
                    )}
                  </CardBody>
                </Card>
              </div>
            )}
          </>
        </AppModal>
      </>
    </div>
  );
};

export default AfasLogs;
